import { SetStateAction } from "react";
import { MRT_Row, MRT_RowSelectionState } from "material-react-table";
import { Box, Grid2, Theme, Typography } from "@mui/material";
import { t } from "i18next";
import { v4 as uuidv4 } from "uuid";
import { basicLayout } from "./constants/basicLayout.constant";
import { AssignedRoomlayout } from "../../../../../Domain/Types/FloorPlan/RoomlayoutAssignment.type";
import { RoomlayoutToggleGrid } from "./partial/RoomlayoutToggleGrid.partial";
import { RoomlayoutServiceRow } from "../../../../../../ServiceManagement/Roomlayout/Domain/Types/FacilityService-Roomlayout-row.types";

export const generateLayoutName = (id: number) => {
  switch (id) {
    case 1:
      return basicLayout[0].name; // "One Table Row"
    case 2:
      return basicLayout[1].name; // "Two Table Row"
    case 3:
      return basicLayout[2].name; // "U Shape"
    case 4:
      return basicLayout[3].name; // "L Shape"
    default:
      return t("New Layout");
  }
};

export const generateLayoutById = (id: number) => {
  switch (id) {
    case 1:
      return basicLayout[0].arrangement; // "One Table Row"
    case 2:
      return basicLayout[1].arrangement; // "Two Table Row"
    case 3:
      return basicLayout[2].arrangement; // "U Shape"
    case 4:
      return basicLayout[3].arrangement; // "L Shape"
    default:
      return basicLayout[0].arrangement;
  }
};

export const renderRoomLayoutSimpleText = (text: string | null) => (
  <Typography>{text ?? ""}</Typography>
);

export const editRoomLayoutCell = (
  layoutCell: Array<boolean[]>,
  row: MRT_Row<RoomlayoutServiceRow>,
  theme: Theme
) => {
  return (
    <Box>
      <Typography sx={{ fontSize: "1rem" }}>{t("Layout")}</Typography>

      {/* room layout switch toggle */}
      <RoomlayoutToggleGrid layoutCell={layoutCell} row={row} theme={theme} />
    </Box>
  );
};

export const renderRoomLayoutCell = (layoutCell: Array<boolean[]>, theme: Theme) => {
  const placeIconBg = theme.palette.mode === "dark" ? "#34353E" : "#D2D2D2";
  const iconFilledWithTheme = theme.palette.mode === "dark" ? "#DBDBDB" : "#444444";
  const placeIconBoxClass = {
    width: "fit-content",
    textAlign: "center",
    backgroundColor: placeIconBg
  };
  const styles = {
    gridItem: { width: "100%", height: "100%" },
    gridContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gridTemplateRows: "repeat(4, 1fr)",
      width: "50px",
      height: "50px"
    }
  };

  return (
    <Grid2 container sx={placeIconBoxClass} data-testid="room-layout-mapping-container">
      <Grid2 sx={{ p: 2 }} data-testid="room-layout-mapping-child">
        <div style={styles.gridContainer}>
          {layoutCell.map(row =>
            row.map(cell => (
              <div
                key={uuidv4()}
                style={{ ...styles.gridItem, backgroundColor: cell ? iconFilledWithTheme : "none" }}
              />
            ))
          )}
        </div>
      </Grid2>
    </Grid2>
  );
};

/** handle the initial room layout item selection in the table  */
export const handleInitialRoomLayoutSelect = (
  assigned: AssignedRoomlayout[],
  setRowSelection: (value: SetStateAction<MRT_RowSelectionState>) => void
) => {
  const usedLayout = assigned.map(as => as.roomLayoutId);
  if (!usedLayout.length) return;
  for (const layout of usedLayout) {
    setRowSelection(prev => ({ ...prev, [`${layout}`]: true }));
  }
};
